import React from "react";

type FileIconProps = React.SVGProps<SVGSVGElement> & { color?: string };

export const FileIcon = ({ width = 24, height = 24, color = "#79808A", ...props }: FileIconProps) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V9l-7-7zM13 2v7h7" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default FileIcon;
